import React from 'react';
import { components } from 'react-select';
import { theme as jcapTheme } from 'theme';
import AsyncSearchSelect, {
  AsyncSearchSelectProps,
} from 'toolbox/src/components/AsyncSearchSelect/AsyncSearchSelect';
import HeroIconCheveronDown from 'toolbox/src/components/HeroIcons/HeroIconCheveronDown';
import './Select.css';
import SelectBase, {
  SelectBaseProps,
} from 'toolbox/src/components/SelectBase/SelectBase';

export const makeJcapReactSelectProps = (props: any) => {
  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <HeroIconCheveronDown className="w-8 h-6 text-gray-600 fill-current" />
      </components.DropdownIndicator>
    );
  };
  return {
    components: {
      DropdownIndicator,
    },
    theme: (theme: any) => ({
      ...theme,
      colors: {
        ...theme.colors,
        primary25: jcapTheme.colors.jcap[100],
        primary: jcapTheme.colors.jcap[200],
      },
    }),
    classNamePrefix: 'ReactSelect',
  };
};

export function JcapAsyncReactSelect<V, Q, O>(
  props: AsyncSearchSelectProps<V, Q, O>,
) {
  return (
    <div className="mb-4">
      {props.label && (
        <label
          htmlFor={props.name}
          className="block text-sm font-bold leading-loose tracking-wide text-gray-600"
        >
          {props.label}
        </label>
      )}
      <AsyncSearchSelect<V, Q, O>
        {...props}
        {...makeJcapReactSelectProps(props)}
      />
      {props.error && (
        <p className="mt-1 text-sm font-semibold tracking-tight text-red-800">
          {props.error}
        </p>
      )}
    </div>
  );
}

export function JcapReactSelect<O>(
  props: SelectBaseProps<O> & { className?: string },
) {
  return (
    <div className={props.className || 'mb-4'}>
      {props.label && (
        <label
          htmlFor={props.name}
          className="block text-sm font-bold leading-loose tracking-wide text-gray-600"
        >
          {props.label}
        </label>
      )}
      <SelectBase<O> {...props} {...makeJcapReactSelectProps(props)} />
      {props.error && (
        <p className="mt-1 text-sm font-semibold tracking-tight text-red-800">
          {props.error}
        </p>
      )}
    </div>
  );
}
